{
  "Sign In - EventLive": "Iniciar sesión - EventLive",
  "Forgot Password - EventLive": "Recuperar contraseña - EventLive",
  "Password Restore Link Sent - EventLive": "Enlace de recuperación enviado - EventLive",
  "Event": "Evento",
  "Event Details": "Detalles del evento",
  "Details": "Detalles",
  "How to Go Live": "Cómo transmitir en vivo",
  "Multi-Camera": "Multicámara",
  "Add a room": "Agregar una sala",
  "Guest List": "Lista de invitados",
  "Import Guests": "Importar invitados",
  "Add a Guest": "Agregar un invitado",
  "Event Analytics": "Estadísticas del evento",
  "Purchase Successful": "Compra realizada",
  "Test EventLive": "Prueba EventLive",
  "Schedule Event": "Programar evento",
  "Download everything": "Descargar todo",
  "Update Email": "Actualizar correo electrónico",
  "Help Us Grow": "Ayúdanos a crecer",
  "Set a New Password - EventLive": "Crear una contraseña nueva - EventLive",
  "Are you sure?": "¿Quieres continuar?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "No se pudieron cargar los datos. Revisa tu conexión a internet. Asegúrate de que la zona horaria, la fecha y la hora de tu dispositivo sean correctas.",
  "Couldn't save your profile": "No se pudo guardar tu perfil",
  "Link required": "El enlace es obligatorio",
  "Overview": "Resumen",
  "{days}-Day Event: {start} – {end}": "Evento de {days} días: {start} – {end}",
  "Close event": "Cerrar evento",
  "This sign-in link has expired": "Este enlace para iniciar sesión ya venció",
  "Couldn't sign you in from this link": "No pudimos iniciar tu sesión con este enlace",
  "Please sign in to continue.": "Inicia sesión para continuar.",
  "Couldn't save your changes": "No se pudieron guardar tus cambios",
  "TEST": "PRUEBA",
  "Download EventLive for Mac": "Descargar EventLive para Mac",
  "Download for": "Descárgalo para",
  "People": "Personas",
  "Team invite - EventLive": "Invitación al equipo - EventLive"
}
